import { jsx } from "react/jsx-runtime";
import constate from "constate";
import { useState } from "react";
import { useModal } from "../hooks/useModal.js";
import FindAndReplaceModal from "../components/Modal/FindAndReplace/FindAndReplaceModal.js";
const useFindAndReplaceModalContext = ({
  onSubmit,
  getFindAndReplaceModalProps,
  columnConfig,
  isFiltered
}) => {
  const [selectedColumnIndex, setSelectedColumnIndex] = useState(-1);
  const [replaceNulls, setReplaceNulls] = useState(false);
  return useModal({
    onOpen: (args) => {
      setSelectedColumnIndex(args.columnIndex);
      setReplaceNulls(args.replaceNulls);
    },
    modal: !onSubmit ? void 0 : (close) => /* @__PURE__ */ jsx(
      FindAndReplaceModal,
      {
        onSubmit,
        columnIndex: selectedColumnIndex,
        columnConfig,
        closeModal: close,
        getFindAndReplaceModalProps,
        replaceNulls,
        isFiltered
      }
    )
  });
};
const [FindAndReplaceProvider, useFindAndReplaceContext] = constate(
  useFindAndReplaceModalContext,
  (value) => value
);
export {
  FindAndReplaceProvider,
  useFindAndReplaceContext,
  useFindAndReplaceModalContext
};
